
import api from '@/api/consult';

export default {
  state: {
    appointments: null,
    appointment: null,
    medicalRecord: null,
    cancelAppointment: null,
    errorMessage: null,
    dependantsAppointments: null,
    attachments: null,
  },

  getters: {
    userAppointments: (state) => state.appointments,
    userDependantsAppointments: (state) => state.dependantsAppointments,
    userAppointmentData: (state) => state.appointment,
    userAppointmetCanceled: (state) => state.cancelAppointment,
    messageError: (state) => state.errorMessage,
    medicalRecord: (state) => state.medicalRecord,
    attachments: (state) => state.attachments,
  },

  actions: {
    async getUserAppointments({ commit }) {
      try {
        const res = await api.getAppointments();

        // Split data appointments into user and dependants appointments
        const [user, dependant] = res.data.reduce(
          ([user, dependant], elem) => elem.agendamento_proprio ? [
            [...user, elem], dependant] : [user, [...dependant, elem]
          ], [[], []]);

        commit('SET_USER_APPOINTMENTS', user);
        commit('SET_USER_DEPENDANTS_APPOINTMENTS', dependant);

        return Promise.resolve(res);
      } catch (e) {
        commit('SET_USER_APPOINTMENTS', null);
        commit('SET_USER_DEPENDANTS_APPOINTMENTS', null);

        return Promise.reject(e);
      }
    },

    async getUserAppointmentData({ commit }, appointmentId) {
      try {
        const res = await api.getAppointmentData(appointmentId);

        commit('SET_USER_APPOINTMENT', res.data);

        return Promise.resolve(res);
      } catch (e) {
        commit('SET_USER_APPOINTMENT', null);

        return Promise.reject(e);
      }
    },

    async cancelUserAppointment({ commit }, appointmentId) {
      try {
        const res = await api.cancelAppointment(appointmentId);

        commit('CANCEL_USER_APPOINTMENT', res.message);

        return Promise.resolve(res);
      } catch (e) {
        commit('CANCEL_USER_APPOINTMENT', null);

        return Promise.reject(e);
      }
    },

    async fetchAttachments({ commit }, appointmentId) {
      try {
        const res = await api.getAttachments(appointmentId);

        commit('SET_ATTACHMENTS', res.data);

        return Promise.resolve(res);
      } catch (e) {
        commit('SET_ATTACHMENTS', null);

        return Promise.reject(e);
      }
    },

    clearErrorMessage({ commit }) {
      commit('SET_ERROR_MESSAGE', null);
    },

    async fetchMedicalReport({ commit }, appointmentId) {
      try {
        const res = await api.getMedicalRecord(appointmentId);

        commit('SET_MEDICAL_REPORT', res.data[0] ?? null);

        return Promise.resolve(res.data);
      } catch (e) {
        commit('SET_MEDICAL_REPORT', null);

        return Promise.reject(e);
      }
    }
  },

  mutations: {
    SET_USER_APPOINTMENTS(state, payload) {
      state.appointments = payload;
    },
    SET_USER_APPOINTMENT(state, payload) {
      state.appointment = payload;
    },
    SET_USER_DEPENDANTS_APPOINTMENTS(state, payload) {
      state.dependantsAppointments = payload;
    },
    CANCEL_USER_APPOINTMENT(state, payload) {
      state.cancelAppointment = payload;
    },
    SET_ERROR_MESSAGE(state, payload) {
      state.errorMessage = payload;
    },
    SET_MEDICAL_REPORT(state, payload) {
      state.medicalRecord = payload;
    },
    SET_ATTACHMENTS(state, payload) {
      state.attachments = payload;
    }
  }
};
